export const CARRIER_PRESETS: Record<string, number> = {
  'IATA Air (6000)': 6000,
  'Express/FedEx (5000)': 5000,
  'DHL Express (5000)': 5000,
  'UPS Air (139 in³/lb)': 139,
  'FedEx Air (139 in³/lb)': 139,
  'Ocean LCL (1000)': 1000,
};
